export * from './stateFromElement';


//////////////////
// WEBPACK FOOTER
// ../draft-js-import-element/esm/main.js
// module id = 962
// module chunks = 22